import { FormikProvider, useFormik } from "formik";
import Autocomplete from "../../../components/Forms/autocomplete";
import CheckBoxGroup from "../../../components/Forms/checkboxGroup";
import FormInput from "../../../components/Forms/input/FormInput";
import UnitLabelledInput from "../../../components/Forms/unitLabelledInput";
import DateTimeInput from "../../../components/Forms/dateTimeInput";
import CustomBPField from "../../../components/Forms/customBPField";
// import useIncident from "../../../hooks/useIncident";
import CustomWoundComp from "../../../components/Forms/customWoundComp";

// test select, radio, dateTime, labelledInput and regular input
interface Form {
  name: string;
  occupation: string;
  state: string;
  notListed: boolean;
  radio: string | string[];
  dateAndTime: string;
  temperature: string;
  bp: string;
  bp2: string;
  orthostatic: boolean;
  perpetrator: {
    role: string;
    name: string;
    nameText: string;
  }[];
  woundSizeL: string;
  woundSizeW: string;
  woundSizeD: string;
}

const formFields = {
  name: "",
  occupation: "",
  state: "",
  notListed: false,
  radio: "",
  dateAndTime: "2023-01-13T03:02:00.000Z",
  temperature: "33, F",
  bp: "",
  bp2: "",
  orthostatic: false,
  perpetrator: [
    {
      role: "",
      name: "",
      nameText: "",
    },
  ],
  woundSizeL: "",
  woundSizeW: "",
  woundSizeD: "",
};

const TestForm = () => {
  // const { createIncidentEntry } = useIncident({ profileId: "" });
  // const { mutateAsync, isLoading } = createIncidentEntry;
  const formik = useFormik({
    initialValues: formFields,
    onSubmit: async (values: Form) => {
      console.log("values", values);
      // mutateAsync(
      //   {
      // }
      // )
    },
  });
  const getError = (fieldName: keyof Form) => {
    return formik.touched[fieldName] && formik.errors[fieldName]
      ? formik.errors[fieldName]
      : null;
  };

  console.log(formik.values);
  // getInjuryTypeOptions()

  return (
    <FormikProvider value={formik}>
      <form onSubmit={formik.handleSubmit}>
        <Autocomplete
          data-testid="autocomplete-name"
          name={"name"}
          errorMessage={getError("name")}
          label={"Name"}
          isImportant
          options={[
            { label: "Name 1", value: "Name 1" },
            { label: "Name 2", value: "Name 2" },
            { label: "Name 3", value: "Name 3" },
          ]} // fetch facilities for options
          setFieldValue={formik.setFieldValue}
          placeholder={"Name"}
          value={formik.values["name"]}
          handleBlur={formik.handleBlur}
          isSearch
        />
        <Autocomplete
          name={"occupation"}
          data-testid="autocomplete-occupation"
          errorMessage={getError("occupation")}
          label={"occupation"}
          isImportant
          options={[
            { label: "Occ 1", value: "Occupation 1" },
            { label: "Occ 2", value: "Occupation 2" },
            { label: "Occ 3", value: "Occupation 3" },
          ]}
          setFieldValue={formik.setFieldValue}
          placeholder={"Occupation"}
          value={formik.values["occupation"]}
          handleBlur={formik.handleBlur}
          showToggleBox
          toggleBoxName={"notListed"}
          toggleBoxLabel={"Not Listed ?"}
        />
        <FormInput
          label={"State"}
          name={"state"}
          data-testid="input-state"
          placeholder={"State"}
          variant="sm"
          onChange={formik.handleChange}
          value={formik.values["state"]}
          onBlur={formik.handleBlur}
          errorMessage={getError("state")}
        />
        <CheckBoxGroup
          options={["Yes", "No"]}
          groupName={"radio"}
          data-testid="checkbox-group-radio"
          isImportant
          errorMessage={getError("radio")}
          label={"Radio"}
          handleChange={formik.getFieldProps}
          disabled
          // isExclusive
        />
        <DateTimeInput
          data-testid="datetime-input-dateAndTime"
          label={"Date & Time of Incident"}
          name={"dateAndTime"}
          placeholder={"Click for Calendar"}
          variant="sm"
          handleChange={formik.setFieldValue}
          value={formik.values["dateAndTime"]}
          onBlur={formik.handleBlur}
          errorMessage={getError("dateAndTime")}
        />
        <UnitLabelledInput
          data-testid="unit-labelled-input-temperature"
          label={"Temperature"}
          name={"temperature"}
          placeholder={"Temperature"}
          variant="sm"
          setFieldValue={formik.setFieldValue}
          value={formik.values["temperature"]}
          onBlur={formik.handleBlur}
          errorMessage={getError("temperature")}
          unitLabel={"F"}
          mask={"###/###"}
        />
        <CustomBPField
          data-testid="custom-bp-field-blood-pressure"
          label={"Blood pressure"}
          placeholder={"bp"}
          variant="sm"
          setFieldValue={formik.setFieldValue}
          onBlur={formik.handleBlur}
          unitLabel={"F"}
          firstFieldName={"bp"}
          secondFieldName={"bp2"}
          checkBoxFieldName={"orthostatic"}
          firstFieldValue={formik.values["bp"]}
          secondFieldValue={formik.values["bp2"]}
          checkBoxValue={formik.values["orthostatic"]}
          onChange={formik.handleChange}
          firstFieldErrorMessage={getError("bp")}
          checkBoxLabel={"Orthostatic"}
        />
        <CustomWoundComp
          data-testid="custom-wound-comp-woundSizeL"
          values={formik.values}
          getErrorMessage={getError}
          onChange={formik.handleChange}
          allWoundFields={[]}
          fieldName={"woundSizeL"}
        />

        <button type="submit">Submit</button>
      </form>
    </FormikProvider>
  );
};

export default TestForm;
